<form [formGroup]="form">
  @for (selector of ogcFiltersSelectors; track selector) {
    <div>
      @if (selector.selectorType === 'pushButton') {
        <div class="pushButtonGroups">
          <mat-divider />
          @if (getPushButtonsGroups().length > 1) {
            <div class="groupsSelector">
              <mat-form-field>
                <mat-select
                  formControlName="pushButtonsGroup"
                  [matTooltip]="'igo.geo.layer.legend.selectStyle' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  [(value)]="currentPushButtonsGroup"
                >
                  @for (
                    selectorGroup of getPushButtonsGroups();
                    track selectorGroup
                  ) {
                    <mat-option [value]="selectorGroup"
                      >{{ selectorGroup.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @for (
            bundle of currentPushButtonsGroup.computedSelectors;
            track bundle
          ) {
            <h4>{{ bundle.title }}</h4>
            <mat-button-toggle-group
              formControlName="pushButtons"
              appearance="legacy"
              vertical="{{ bundleIsVertical(bundle) }}"
              multiple="true"
            >
              @for (ogcPushButton of bundle.selectors; track ogcPushButton) {
                <mat-button-toggle
                  [matTooltip]="getToolTip(ogcPushButton)"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  [ngStyle]="getButtonColor(ogcPushButton)"
                  [checked]="ogcPushButton.enabled"
                  (change)="
                    onSelectionChange(ogcPushButton, selector.selectorType)
                  "
                  [value]="ogcPushButton"
                  >{{ ogcPushButton.title }}
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          }
        </div>
      }
      @if (selector.selectorType === 'checkbox') {
        <div class="checkboxGroups">
          <mat-divider />
          @if (getCheckboxesGroups().length > 1) {
            <div class="groupsSelector">
              <mat-form-field>
                <mat-select
                  formControlName="checkboxesGroup"
                  [matTooltip]="'igo.geo.layer.legend.selectStyle' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  [(value)]="currentCheckboxesGroup"
                >
                  @for (
                    selectorGroup of getCheckboxesGroups();
                    track selectorGroup
                  ) {
                    <mat-option [value]="selectorGroup"
                      >{{ selectorGroup.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @for (
            bundle of currentCheckboxesGroup.computedSelectors;
            track bundle
          ) {
            <h4>{{ bundle.title }}</h4>
            <div class="checkboxes">
              @for (ogcCheckbox of bundle.selectors; track ogcCheckbox) {
                <mat-checkbox
                  [matTooltip]="getToolTip(ogcCheckbox)"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  [checked]="ogcCheckbox.enabled"
                  (change)="
                    onSelectionChange(ogcCheckbox, selector.selectorType)
                  "
                  [value]="ogcCheckbox"
                  >{{ ogcCheckbox.title }}
                </mat-checkbox>
              }
            </div>
            @if (
              isLessResults(bundle, 'checkbox') ||
              isMoreResults(bundle, 'checkbox')
            ) {
              <p>
                @if (isLessResults(bundle, 'checkbox')) {
                  <u
                    class="lessResults"
                    (click)="displayLessResults('checkbox')"
                    >{{ 'igo.geo.filter.displayLessResults' | translate }}
                  </u>
                }
                @if (isMoreResults(bundle, 'checkbox')) {
                  <u
                    class="moreResults"
                    (click)="displayMoreResults('checkbox')"
                    >{{ 'igo.geo.filter.displayMoreResults' | translate }}
                  </u>
                }
              </p>
            }
          }
        </div>
      }
      @if (selector.selectorType === 'radioButton') {
        <div class="radioButtonGroups">
          <mat-divider />
          @if (getRadioButtonsGroups().length > 1) {
            <div class="groupsSelector">
              <mat-form-field>
                <mat-select
                  formControlName="radioButtonsGroup"
                  [matTooltip]="'igo.geo.layer.legend.selectStyle' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  [(value)]="currentRadioButtonsGroup"
                >
                  @for (
                    selectorGroup of getRadioButtonsGroups();
                    track selectorGroup
                  ) {
                    <mat-option [value]="selectorGroup"
                      >{{ selectorGroup.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @for (
            bundle of currentRadioButtonsGroup.computedSelectors;
            track bundle
          ) {
            <h4>{{ bundle.title }}</h4>
            <mat-radio-group formControlName="radioButtons">
              @if (bundle.unfiltered) {
                <mat-radio-button
                  [matTooltip]="'igo.geo.filter.resetFilters' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  (change)="emptyRadioButtons()"
                  >{{ 'igo.geo.filter.resetFilters' | translate }}
                </mat-radio-button>
              }
              @for (ogcRadioButton of bundle.selectors; track ogcRadioButton) {
                <mat-radio-button
                  [matTooltip]="getToolTip(ogcRadioButton)"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  [checked]="ogcRadioButton.enabled"
                  (change)="
                    onSelectionChange(ogcRadioButton, selector.selectorType)
                  "
                  [value]="ogcRadioButton"
                  >{{ ogcRadioButton.title }}
                </mat-radio-button>
              }
              @if (
                isLessResults(bundle, 'radio') || isMoreResults(bundle, 'radio')
              ) {
                <p>
                  @if (isLessResults(bundle, 'radio')) {
                    <u class="lessResults" (click)="displayLessResults('radio')"
                      >{{ 'igo.geo.filter.displayLessResults' | translate }}
                    </u>
                  }
                  @if (isMoreResults(bundle, 'radio')) {
                    <u class="moreResults" (click)="displayMoreResults('radio')"
                      >{{ 'igo.geo.filter.displayMoreResults' | translate }}
                    </u>
                  }
                </p>
              }
            </mat-radio-group>
          }
        </div>
      }
      @if (selector.selectorType === 'select') {
        <div class="selectGroups">
          <mat-divider />
          @if (getSelectGroups().length > 1) {
            <div class="groupsSelector">
              <mat-form-field>
                <mat-select
                  formControlName="selectGroup"
                  [matTooltip]="'igo.geo.layer.legend.selectStyle' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  [(value)]="currentSelectGroup"
                >
                  @for (
                    selectorGroup of getSelectGroups();
                    track selectorGroup
                  ) {
                    <mat-option [value]="selectorGroup"
                      >{{ selectorGroup.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @for (bundle of currentSelectGroup.computedSelectors; track bundle) {
            <h4>{{ bundle.title }}</h4>
            <div class="groupsSelector">
              @if (bundle.unfiltered && !bundle.multiple) {
                <mat-button
                  mat-icon-button
                  color="warn"
                  [matTooltip]="'igo.geo.filter.resetFilters' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  (click)="emptySelect()"
                >
                  <mat-icon>filter_alt_off</mat-icon>
                </mat-button>
              }
              <mat-form-field
                [style.width.%]="bundle.width ? bundle.width : undefined"
              >
                @if (bundle.multiple) {
                  <div>
                    <mat-select
                      #selection
                      [multiple]="bundle.multiple"
                      [placeholder]="bundle.title"
                      formControlName="selectMulti"
                    >
                      <div class="checkboxes">
                        @if (bundle.multiple) {
                          <mat-checkbox
                            [(ngModel)]="selectAllSelected"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="toggleAllSelection()"
                            >Tous
                          </mat-checkbox>
                        }
                      </div>
                      @for (ogcSelect of bundle.selectors; track ogcSelect) {
                        <mat-option
                          [matTooltip]="getToolTip(ogcSelect)"
                          tooltip-position="below"
                          matTooltipDelay="500"
                          matTooltipClass="material-tooltip"
                          (onSelectionChange)="
                            selectOptionClick(
                              $event.source.value,
                              bundle,
                              $event
                            )
                          "
                          [value]="ogcSelect"
                          >{{ ogcSelect.title }}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                } @else {
                  <mat-select
                    [placeholder]="bundle.title"
                    formControlName="select"
                  >
                    @for (ogcSelect of bundle.selectors; track ogcSelect) {
                      <mat-option
                        [matTooltip]="getToolTip(ogcSelect)"
                        tooltip-position="below"
                        matTooltipDelay="500"
                        matTooltipClass="material-tooltip"
                        [value]="ogcSelect"
                        (onSelectionChange)="
                          selectOptionClick($event.source.value, bundle)
                        "
                        >{{ ogcSelect.title }}
                      </mat-option>
                    }
                  </mat-select>
                }
              </mat-form-field>
            </div>
          }
        </div>
      }
      @if (selector.selectorType === 'autocomplete') {
        <div class="autocompleteGroups">
          <mat-divider />
          @if (getAutocompleteGroups().length > 1) {
            <div class="groupsSelector">
              <mat-form-field>
                <mat-select
                  formControlName="autocompleteGroup"
                  [matTooltip]="'igo.geo.layer.legend.selectStyle' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  [(value)]="currentAutocompleteGroup"
                >
                  @for (
                    autocompleteGroup of getAutocompleteGroups();
                    track autocompleteGroup
                  ) {
                    <mat-option [value]="autocompleteGroup"
                      >{{ autocompleteGroup.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @for (
            bundle of currentAutocompleteGroup.computedSelectors;
            track bundle
          ) {
            <h4>{{ bundle.title }}</h4>
            <div class="groupsSelector">
              @if (bundle.unfiltered) {
                <mat-button
                  mat-icon-button
                  color="warn"
                  [matTooltip]="'igo.geo.filter.resetFilters' | translate"
                  tooltip-position="below"
                  matTooltipShowDelay="500"
                  matTooltipClass="material-tooltip"
                  (click)="emptyAutocomplete()"
                >
                  <mat-icon>filter_alt_off</mat-icon>
                </mat-button>
              }
              @if (filteredOgcAutocomplete[bundle.id]) {
                <mat-form-field
                  floatLabel="always"
                  [style.width.%]="bundle.width ? bundle.width : undefined"
                >
                  <mat-label>{{ bundle.title }}</mat-label>
                  @if (
                    filteredOgcAutocomplete[bundle.id] &&
                    (bundle.showChips ?? true)
                  ) {
                    <mat-chip-set>
                      @for (
                        autocompleteEnabled of autocompleteEnableds;
                        track autocompleteEnabled
                      ) {
                        <mat-chip
                          (removed)="toggleSelection(autocompleteEnabled)"
                        >
                          {{ autocompleteEnabled }}
                          <button
                            matChipRemove
                            [matTooltip]="
                              'igo.geo.filter.removeFilter' | translate
                            "
                          >
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip>
                      }
                    </mat-chip-set>
                  }
                  <input
                    matInput
                    type="text"
                    formControlName="autocomplete"
                    #input
                    [matAutocomplete]="auto"
                    (input)="onInputChange()"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    @for (
                      ogcAutocomplete of filteredOgcAutocomplete[bundle.id]
                        | async;
                      track ogcAutocomplete
                    ) {
                      <mat-option
                        id="mat-option"
                        [matTooltip]="getToolTip(ogcAutocomplete)"
                      >
                        <div
                          (click)="
                            toggleAutocompleteOption(
                              $event,
                              ogcAutocomplete.value
                            )
                          "
                        >
                          <mat-checkbox
                            id="mat-checkbox"
                            color="primary"
                            [checked]="checkedStatus(ogcAutocomplete.value)"
                            (click)="
                              toggleAutocompleteOption(
                                $event,
                                ogcAutocomplete.value
                              )
                            "
                          />
                          {{ ogcAutocomplete.value }}
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</form>

@if (isTemporalOperator()) {
  <div>
    <mat-divider />
    @if (!currentFilter.title) {
      <h4>
        {{ 'igo.geo.filter.reportingDate' | translate }}
      </h4>
    }
    @if (currentFilter.title) {
      <h4>{{ currentFilter.title }}</h4>
    }
    <igo-ogc-filter-time
      [datasource]="datasource()"
      [currentFilter]="currentFilter"
      (changeProperty)="changeProperty($event.value, $event.pos)"
    />
  </div>
}
